export default __webpack_public_path__ + "static/media/fusion-header.4a64d963.jpeg";